import { Injectable } from '@angular/core';
import { ApplicationVersionDataService } from '../data-services/application-version-data.service';
import { ApplicationVersionListRequestModel } from '../business-entities/application-version-list-model';

@Injectable({
    providedIn: 'root'
})

export class ApplicationVersionService {
    applicationVersionListRequest: ApplicationVersionListRequestModel =
        {
            
            startRecordNumber: 0,
            pageSize: 25,
            sortColumn: '',
            sortDirection: '',
            versionNumber:''
        }
    constructor(private service: ApplicationVersionDataService) {
    }

    async getApplicationVersionList(applicationVersionListRequest: any) {
        return this.service.getApplicationVersionList(applicationVersionListRequest);
    }
    async getVersionNumberList() {
        return this.service.getVersionNumberList();
    }
    async addApplicationVersion(viewModel:any){
        return this.service.addApplicationVersion(viewModel);
    }
    async getApplicationVersionById(id:number){
        return this.service.getApplicationVersionById(id);
    }
    async editApplicationVersion(viewModel:any){
        return this.service.editApplicationVersion(viewModel);
    }
}
